import { createSlice } from "@reduxjs/toolkit";


export const clientSlice = createSlice({
    name: 'client',
    initialState:{},
    reducers: { // 
        setClient: (currentState, action) => {
            return (action.payload);
        },
        
       
    }
});

